// Central content for Vertexhub Ventures marketing site.

// Central config for the Section 8 landing page.
// Set bookingUrl to a Calendly (or other) link to make all "Book a Consultation"
// buttons open real scheduling; leave empty to scroll to the contact form.
export const SECTION8 = {
  bookingUrl: "",
  markets: ["Pennsylvania"],
};

export const BRAND = {
  name: "Vertexhub Ventures",
  phone: "(215) 445-4257",
  phoneHref: "tel:+12154454257",
  email: "hello@vhubagent.com",
  address: "4387 W Swamp Rd, Suite 109, Doylestown, PA 18902",
  addressHref: "https://www.google.com/maps/search/?api=1&query=4387+W+Swamp+Rd+Suite+109+Doylestown+PA+18902",
  offices: [
    { name: "Doylestown Office", address: "4387 W Swamp Rd, Suite 109, Doylestown, PA 18902", href: "https://www.google.com/maps/search/?api=1&query=4387+W+Swamp+Rd+Suite+109+Doylestown+PA+18902" },
  ],
  googleReviewUrl: "",
  sampleReportUrl: "",
  taglinePrimary: "From Winning Bid to Possession.",
  taglineSecondary:
    "Your Local Partner for Auction Properties, Post-Purchase Support & Investor Financing.",
  motto: "Buy. Secure. Finance. Manage.",
  coreMessage: "One Property. One Team. One Point of Contact.",
  markets: "Bucks & Montgomery (PA) • Dauphin • Northumberland • Montour • Columbia • Snyder • Union • Schuylkill • Luzerne • Lycoming • Carbon — Pennsylvania",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1625447521754-764d517239e6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  facade: "https://images.pexels.com/photos/17187918/pexels-photo-17187918.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  courthouse: "https://images.unsplash.com/photo-1665456945179-02fcf14d0f2d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  courthouseClassic: "https://images.unsplash.com/photo-1676517201570-beb8e2f36ede?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  interior: "https://images.unsplash.com/photo-1613545325278-f24b0cae1224?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  spacious: "https://images.pexels.com/photos/8146144/pexels-photo-8146144.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  kitchen: "https://images.unsplash.com/photo-1628745277862-bc0b2d68c50c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

export const NAV_LINKS = [
  {
    label: "Inspections",
    children: [
      { label: "All Inspections & Pricing", to: "/inspections" },
      { label: "Book an Inspection", to: "/property-inspections/book" },
      { label: "Field Services & Preservation", to: "/field-services" },
      { label: "Get a Quote", to: "/request-inspection" },
    ],
  },
  { label: "Property Preservation", to: "/property-preservation" },
  {
    label: "For Investors",
    children: [
      { label: "PA Auction Support", to: "/packages" },
      { label: "Section 8 Investment Support", to: "/section8" },
      { label: "Financing Support", to: "/financing" },
      { label: "Wholesale", to: "/wholesale" },
      { label: "Buy", to: "/buy" },
      { label: "Sell", to: "/sell" },
      { label: "Rehab Project Management", to: "/rehab-project-management" },
    ],
  },
  { label: "Service Areas", to: "/service-areas" },
  { label: "About", to: "/about" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];

export const OLD_NAV_LINKS = [
  {
    label: "Services",
    children: [
      { label: "Auction Services", to: "/services/auction-services" },
      { label: "Pre-Auction Support", to: "/services/pre-auction" },
      { label: "Auction Day Support", to: "/services/auction-day" },
      { label: "Post-Auction Support", to: "/services/post-auction" },
      { label: "Property Inspections", to: "/services/inspections" },
      { label: "Inspection Pricing & Booking", to: "/property-inspections" },
      { label: "Possession Support", to: "/services/possession" },
    ],
  },
  {
    label: "Property Inspections & Field Services",
    children: [
      { label: "All Field Services", to: "/field-services" },
      { label: "Residential & Commercial Inspections", to: "/field-services/residential-commercial" },
      { label: "Mortgage & Financial Field Services", to: "/field-services/mortgage-financial" },
      { label: "Construction & Draw Inspections", to: "/field-services/construction" },
      { label: "Property Preservation & Maintenance", to: "/field-services/preservation-maintenance" },
      { label: "Commercial Verification Services", to: "/field-services/commercial-verification" },
      { label: "Property Occupancy & Quality Control", to: "/field-services/occupancy-quality" },
      { label: "Request an Inspection", to: "/request-inspection" },
    ],
  },
  {
    label: "Financing",
    children: [
      { label: "Financing Overview", to: "/financing" },
      { label: "DSCR Loans", to: "/financing/dscr" },
      { label: "Fix & Flip", to: "/financing/fix-and-flip" },
      { label: "Hard Money", to: "/financing/hard-money" },
      { label: "Bridge Financing", to: "/financing/bridge" },
      { label: "Rental Financing", to: "/financing/rental" },
      { label: "Portfolio Financing", to: "/financing/portfolio" },
    ],
  },
  { label: "Packages", to: "/packages" },
  { label: "Wholesale", to: "/wholesale" },
  { label: "I Want to Buy", to: "/buy" },
  { label: "I Want to Sell", to: "/sell" },
  { label: "Section 8", to: "/section8" },
  { label: "Register Buy Box", to: "/register-buy-box" },
  { label: "Register Deal", to: "/register-deal" },
  {
    label: "More",
    children: [
      { label: "How It Works", to: "/how-it-works" },
      { label: "Counties We Serve", to: "/counties" },
      { label: "Northumberland County", to: "/pa-auction-services/northumberland-county" },
      { label: "About Vertexhub", to: "/about" },
      { label: "FAQ", to: "/faq" },
      { label: "Contact", to: "/contact" },
    ],
  },
];

export const PROCESS_STEPS = [
  { n: "01", name: "FIND", desc: "Identify sheriff, tax and foreclosure auction opportunities in your target markets." },
  { n: "02", name: "REVIEW", desc: "Pre-auction exterior drive-by, condition check and coordination with title professionals." },
  { n: "03", name: "FINANCE", desc: "Explore DSCR, hard money, bridge or fix-and-flip options before you bid." },
  { n: "04", name: "BUY", desc: "Auction-day logistics and support while you participate in the transaction." },
  { n: "05", name: "CLOSE", desc: "Confirmation, final-payment, deed and recording tracking to recorded ownership." },
  { n: "06", name: "POSSESSION", desc: "Lawful possession, writ and eviction coordination with the right professionals." },
  { n: "07", name: "SECURE", desc: "Re-keying, board-up, utilities and winterization to stabilize the asset." },
  { n: "08", name: "REHAB / RENT / SELL", desc: "Contractor coordination, scope of work and property-management handoff." },
];

export const BENEFITS = [
  { icon: "MapPin", title: "Local Presence", desc: "Someone on the ground when you cannot be there." },
  { icon: "CalendarClock", title: "Deadline Tracking", desc: "Auction and post-sale deadlines organized in one place." },
  { icon: "FolderCheck", title: "Property Documentation", desc: "Photos, videos, inspection observations, receipts and available ownership documents." },
  { icon: "Users", title: "Vendor Coordination", desc: "Locksmiths, contractors, clean-out crews and other local providers." },
  { icon: "KeyRound", title: "Possession Support", desc: "Coordination of lawful post-purchase possession processes." },
  { icon: "Landmark", title: "Investor Financing", desc: "Help exploring DSCR, hard money, bridge, fix-and-flip and other options." },
];

export const SERVICES = {
  "auction-services": {
    title: "Auction Services",
    eyebrow: "End-to-End Auction Support",
    headline: "One Team From Research to Recorded Ownership.",
    intro:
      "Vertexhub Ventures coordinates the operational side of buying investment properties at county, sheriff, tax and foreclosure auctions — so remote investors get local execution without the operational burden.",
    image: IMAGES.courthouse,
    sections: [
      { title: "Before the Auction", items: ["Property & parcel research", "Auction-date and requirement verification", "Exterior inspection, photos and video", "Neighborhood and visible occupancy observations", "Auction-document organization"] },
      { title: "On Auction Day", items: ["Auction-registration preparation", "Auction-day logistics and support", "Winning-bid documentation", "Deposit and payment-instruction tracking", "Immediate post-auction action plan"] },
      { title: "After the Auction", items: ["Confirmation-of-sale monitoring", "Final-payment coordination", "Deed and recording follow-up", "Occupancy verification and possession coordination", "Property securing and stabilization"] },
    ],
    cta: { label: "SUBMIT A PROPERTY", to: "/submit-property" },
    note: "Bidding or representation on behalf of a client is offered only when permitted by applicable auction rules and law.",
  },
  "pre-auction": {
    title: "Pre-Auction Support",
    eyebrow: "Due Diligence",
    headline: "Know What You're Bidding On Before You Bid.",
    intro:
      "Reduce surprises with a structured pre-auction review coordinated by a local team, covering the property, the neighborhood and the auction requirements.",
    image: IMAGES.facade,
    sections: [
      { title: "Property Research", items: ["Property research", "Parcel research", "Auction information review", "Auction-date verification", "Minimum-bid verification", "Deposit requirement verification", "Payment deadline verification"] },
      { title: "Exterior Review", items: ["Exterior property inspection", "Property photos and videos", "Neighborhood observations", "Visible occupancy observations from lawful/public areas", "Preliminary visible-condition assessment"] },
      { title: "Acquisition Prep", items: ["Auction-document organization", "Investor acquisition checklist", "Property logistics planning", "Coordination with third-party title professionals when requested", "Preliminary rehab observations where appropriate"] },
    ],
    cta: { label: "REQUEST PRE-AUCTION REVIEW", to: "/submit-property" },
    note: "Interior inspections are subject to lawful access and property availability.",
  },
  "auction-day": {
    title: "Auction Day Support",
    eyebrow: "Live Execution",
    headline: "Local Support When the Auction Starts.",
    intro:
      "Depending on applicable auction rules and legal requirements, Vertexhub provides real-time local coordination on auction day.",
    image: IMAGES.courthouseClassic,
    sections: [
      { title: "Preparation", items: ["Auction-registration preparation", "Auction-day logistics", "Bid-limit documentation"] },
      { title: "During the Auction", items: ["In-person investor support", "Real-time communication", "Winning-bid documentation"] },
      { title: "Immediately After", items: ["Deposit coordination", "Payment-instruction tracking", "Collection and organization of auction receipts", "Immediate post-auction action plan"] },
    ],
    cta: { label: "REQUEST AUCTION DAY SUPPORT", to: "/submit-property" },
    note: "Vertexhub does not claim to legally bid on behalf of every customer. Bidding or representation is offered only when permitted by applicable auction rules and law.",
  },
  "post-auction": {
    title: "Post-Auction Support",
    eyebrow: "After the Gavel",
    headline: "Winning the Auction Is Only Step One.",
    intro:
      "From winning bid to recorded ownership and stabilization, Vertexhub tracks the deadlines and coordinates the vendors that turn a purchase into a controlled asset.",
    image: IMAGES.interior,
    timeline: ["Winning Bid", "Deposit", "Confirmation", "Final Payment", "Deed", "Recording", "Possession", "Property Secured", "Rehab / Rent / Sell"],
    sections: [
      { title: "Payment & Confirmation", items: ["Payment-deadline tracking", "Confirmation-of-sale monitoring", "Final-payment coordination"] },
      { title: "Deed & Ownership", items: ["Deed status monitoring", "Recording status monitoring", "Recorded deed retrieval assistance", "County-record verification"] },
      { title: "Property Setup", items: ["Property reinspection", "Occupancy verification", "Locksmith and utility coordination", "Clean-out and contractor access", "Rehab walk-through and property stabilization"] },
    ],
    cta: { label: "SUBMIT A PROPERTY", to: "/submit-property" },
  },
  inspections: {
    title: "Property Inspections",
    eyebrow: "Eyes on the Ground",
    headline: "Documented, Visible-Condition Observations.",
    intro:
      "Exterior auction inspections and post-purchase interior inspections with photos, video and room-by-room observations once lawful access is available.",
    image: IMAGES.spacious,
    sections: [
      { title: "Exterior Auction Inspection", items: ["Exterior photos and video", "Roof observations from accessible areas", "Visible foundation and siding condition", "Windows, doors and yard condition", "Visible damage and neighborhood observations", "Apparent occupancy observations"] },
      { title: "Post-Purchase Inspection", items: ["Interior photos and video", "Room-by-room observations", "Visible plumbing, electrical and HVAC observations", "Kitchen, bathroom and flooring condition", "Visible structural concerns", "Rehab observations"] },
    ],
    cta: { label: "REQUEST AN INSPECTION", to: "/submit-property" },
    note: "These are documented visual observations. They are not licensed engineering or specialized home inspections unless performed by the appropriate licensed professionals.",
  },
  possession: {
    title: "Possession Support",
    eyebrow: "Lawful Possession",
    headline: "Coordinated Possession, Done the Right Way.",
    intro:
      "When a property is occupied, Vertexhub coordinates lawful possession processes with the appropriate attorneys, courts, sheriffs and vendors.",
    image: IMAGES.facade,
    sections: [
      { title: "Occupancy & Possession", items: ["Post-purchase occupancy verification", "Property reinspection", "Documentation of apparent occupancy", "Occupant communication coordination when legally appropriate", "Voluntary move-out coordination when applicable", "Possession timeline management"] },
      { title: "Writ of Possession Coordination", items: ["Coordination with a Pennsylvania attorney when required", "Organization of purchaser/deed documentation", "Court-status monitoring", "Sheriff scheduling follow-up", "Lockout-date and locksmith coordination"] },
      { title: "Eviction / Removal Coordination", items: ["Attorney and sheriff coordination when required", "Vendor, locksmith and clean-out scheduling", "Moving/labor coordination when required", "Property-condition documentation", "Before-and-after photos and possession confirmation"] },
    ],
    cta: { label: "CHOOSE FULL POSSESSION SUPPORT", to: "/packages" },
    note: "Vertexhub coordinates lawful possession processes and does not perform unlawful lockouts or removals. Attorney, court and sheriff fees are billed separately.",
  },
};

export const ADDONS = [
  { title: "Pre-Auction Inspection", desc: "Exterior photos, videos and visible-condition observations." },
  { title: "Title Research Coordination", desc: "Coordination with qualified title professionals for title/lien review." },
  { title: "Rehab Assessment", desc: "Contractor walk-through and preliminary renovation estimate after lawful access." },
  { title: "Property Clean-Out", desc: "Dumpster and clean-out crew coordination." },
  { title: "Property Preservation", desc: "Lock changes, boarding, lawn care and winterization coordination." },
  { title: "Utility Setup", desc: "Water, electric and gas activation coordination." },
  { title: "Contractor Coordination", desc: "Local contractor sourcing, scheduling and access management." },
  { title: "Property Management Setup", desc: "Coordination with local property-management providers." },
];

export const PACKAGES = [
  {
    id: "acquisition",
    name: "Auction Acquisition & Closing Support",
    price: "$2,000",
    subtitle: "From Winning Bid to Recorded Ownership",
    highlight: false,
    groups: [
      { label: "Property Inspection", items: ["Exterior property inspection", "Photos & video", "Visible-condition report", "Neighborhood observations", "Visible occupancy assessment", "Initial stabilization recommendations"] },
      { label: "Auction Documentation", items: ["Winning-bid document organization", "Auction-receipt verification", "Payment-deadline tracking", "Confirmation-of-sale monitoring", "Final-payment reminders & coordination"] },
      { label: "Deed & Ownership", items: ["Confirmation & deed status monitoring", "Recording status follow-up", "Recorded deed retrieval assistance", "County-record verification", "Digital property file"] },
      { label: "Post-Purchase Setup", items: ["Property-status verification", "Exterior reinspection", "Locksmith & utility coordination", "Contractor-access coordination", "Clean-out estimate & rehab walk-through coordination"] },
    ],
    cta: "CHOOSE ACQUISITION SUPPORT",
    disclaimer: "Government charges, recording fees, title services, contractors, locksmiths, utilities and other third-party expenses are not included.",
  },
  {
    id: "possession",
    name: "Auction Acquisition + Possession Support",
    price: "$3,500",
    subtitle: "From Winning Bid to Property Possession",
    badge: "MOST COMPLETE",
    highlight: true,
    intro: "Includes everything in the $2,000 package, plus:",
    groups: [
      { label: "Occupancy & Possession Coordination", items: ["Post-purchase occupancy verification", "Property reinspection", "Documentation of apparent occupancy", "Occupant communication when legally appropriate", "Voluntary move-out coordination", "Possession timeline management"] },
      { label: "Writ of Possession Coordination", items: ["Coordination with a Pennsylvania attorney when required", "Purchaser/deed documentation", "Court-status monitoring", "Sheriff scheduling follow-up", "Lockout-date & locksmith coordination"] },
      { label: "Eviction / Possession Coordination", items: ["Attorney & sheriff coordination when required", "Vendor, locksmith & clean-out scheduling", "Moving/labor coordination", "Before-and-after photos", "Possession confirmation"] },
      { label: "Property Securing + Final Report", items: ["Lock-change & entry-point inspection", "Boarding & utility coordination", "Clean-out estimates & contractor access", "Ownership + possession status report", "Work performed, vendors & next steps"] },
    ],
    cta: "CHOOSE FULL POSSESSION SUPPORT",
    disclaimer: "Attorney fees, court filing fees, sheriff fees, locksmith charges, movers, dumpsters, clean-out labor, storage, contractors and other third-party expenses are billed separately. This is eviction / possession coordination, not \"eviction included\".",
  },
];

export const FINANCING_PRODUCTS = {
  dscr: {
    title: "DSCR Rental Property Financing",
    eyebrow: "Rental Cash-Flow Lending",
    headline: "Qualify on the Property, Not Just Your Paystub.",
    rate: "Through partner lenders",
    ltv: "Terms set by the lender",
    intro: "DSCR financing may allow investors to qualify primarily based on the property's rental cash flow and lender underwriting requirements rather than relying exclusively on traditional personal-income qualification.",
    uses: ["Single-family rentals", "Long-term rentals", "Eligible short-term rentals", "Small residential portfolios", "Purchase financing", "Refinance", "Cash-out refinance where eligible"],
    cta: "EXPLORE DSCR FINANCING",
    disclaimer: "Loan eligibility, DSCR requirements, reserves, credit requirements, property eligibility, rates and terms vary by lender and program.",
  },
  "hard-money": {
    title: "Hard Money Financing",
    eyebrow: "Speed Capital",
    headline: "Fast Capital for Investor Acquisitions.",
    rate: "Through partner lenders",
    ltv: "Terms set by the lender",
    intro: "Property-based, investor-focused capital structured for time-sensitive auction and distressed acquisitions.",
    uses: ["Auction purchases", "Fix-and-flip properties", "Distressed properties", "Time-sensitive acquisitions", "Renovation properties"],
    cta: "REQUEST HARD MONEY OPTIONS",
    disclaimer: "Investor-focused and property-based underwriting, short-term structures and faster closing options depend on the lender and program.",
  },
  "fix-and-flip": {
    title: "Fix & Flip Financing",
    eyebrow: "Purchase + Rehab",
    headline: "Fund the Purchase and the Rehab.",
    rate: "Through partner lenders",
    ltv: "Terms set by the lender",
    intro: "Short-term value-add financing combining acquisition funding with a rehab budget and draw schedule.",
    uses: ["Acquisition funding", "Rehab funding", "Draw schedules", "Interest-only structures", "Investor-focused underwriting"],
    cta: "FINANCE A FIX & FLIP",
    disclaimer: "Leverage, draw schedules, rates and terms are determined by the lender and program.",
  },
  bridge: {
    title: "Bridge Financing",
    eyebrow: "Transitional Capital",
    headline: "Bridge Financing for Transitional Properties.",
    rate: "Through partner lenders",
    ltv: "Terms set by the lender",
    intro: "Short-term liquidity to hold or transition properties while awaiting permanent financing.",
    uses: ["Auction acquisitions", "Transitional properties", "Renovation", "Delayed permanent financing", "Portfolio acquisitions"],
    cta: "EXPLORE BRIDGE FINANCING",
    disclaimer: "Terms and eligibility vary by lender and program.",
  },
  rental: {
    title: "Rental Property Financing",
    eyebrow: "Buy & Hold",
    headline: "Build Your Rental Portfolio.",
    rate: "Through partner lenders",
    ltv: "Terms set by the lender",
    intro: "Long-term financing for stabilized rentals and buy-and-hold strategies.",
    uses: ["Buy-and-hold", "Rental portfolio expansion", "Stabilized rentals", "Rate-and-term refinance", "Cash-out refinance where eligible"],
    cta: "EXPLORE RENTAL FINANCING",
    disclaimer: "Terms and eligibility vary by lender and program.",
  },
  portfolio: {
    title: "Portfolio Financing",
    eyebrow: "Scale",
    headline: "Financing for Multiple Investment Properties.",
    rate: "Through partner lenders",
    ltv: "Terms set by the lender",
    intro: "Consolidate or expand multiple properties under portfolio and blanket loan structures.",
    uses: ["Portfolio loans", "Blanket loans", "Multiple-property acquisitions", "Rental portfolio refinance", "Business-purpose financing"],
    cta: "DISCUSS PORTFOLIO FINANCING",
    disclaimer: "Terms and eligibility vary by lender and program.",
  },
};

export const FINANCING_STEPS = [
  { n: "1", title: "Submit Your Deal", desc: "Property, purchase price, auction/closing date, ARV, rehab, property type, rent and strategy." },
  { n: "2", title: "Financing Review", desc: "We organize your transaction information and identify potential financing categories." },
  { n: "3", title: "Lender Matching", desc: "Where appropriate, we coordinate introductions to third-party financing providers." },
  { n: "4", title: "Application Support", desc: "We help organize documentation and communication." },
  { n: "5", title: "Closing Coordination", desc: "We track outstanding financing items and acquisition deadlines." },
];

export const COUNTIES = {
  primary: {
    name: "Northumberland County",
    region: "Sunbury Hub · Pennsylvania",
    cities: ["Sunbury", "Shamokin", "Coal Township", "Milton", "Mount Carmel", "Northumberland", "Watsontown"],
  },
  groups: [
    { region: "Susquehanna Valley", counties: ["Union County (Lewisburg)", "Snyder County (Selinsgrove)", "Montour County (Danville)", "Columbia County (Bloomsburg)", "Lycoming County (Williamsport)"] },
    { region: "Coal Region & Northeast PA", counties: ["Schuylkill County (Pottsville)", "Luzerne County (Wilkes-Barre / Hazleton)"] },
    { region: "Capital Region", counties: ["Dauphin County (Harrisburg)"] },
  ],
};

export const FAQS = [
  { q: "Do I need to live in Pennsylvania?", a: "No. Vertexhub Ventures is designed to help investors who need local acquisition and property support." },
  { q: "Do you guarantee clear title?", a: "No. Title opinions should be obtained from appropriately qualified title or legal professionals." },
  { q: "Can you inspect inside the property before auction?", a: "Only when lawful access is available." },
  { q: "Can you remove occupants?", a: "Vertexhub coordinates lawful possession processes with appropriate professionals and authorities when required. Vertexhub does not perform unlawful lockouts or removals." },
  { q: "Are attorney fees included in the $3,500 package?", a: "No. Attorney, court, sheriff and other third-party expenses are separate." },
  { q: "Can Vertexhub bid for me?", a: "Auction representation or bidding assistance is available only when permitted by applicable law and auction rules." },
  { q: "Do you guarantee possession?", a: "No. Timelines and outcomes depend on the property, occupants, court procedures and applicable law." },
  { q: "What areas do you serve?", a: "Doylestown and surrounding Bucks and Montgomery county (PA) towns, the Harrisburg area (Dauphin County), and Central PA within about an hour of Coal Township: Northumberland, Montour, Columbia, Snyder, Union, Schuylkill, Luzerne, Lycoming and Carbon counties." },
  { q: "Does Vertexhub provide financing?", a: "Vertexhub helps investors explore and coordinate financing options through appropriate financing providers. Availability, approval and terms depend on the financing provider and program." },
  { q: "Is financing guaranteed?", a: "No." },
];

export const PORTAL_STAGES = [
  "PRE-AUCTION", "AUCTION SCHEDULED", "WON", "DEPOSIT PAID", "AWAITING CONFIRMATION",
  "CONFIRMED", "FINAL PAYMENT DUE", "PAID IN FULL", "AWAITING DEED", "DEED RECORDED",
  "OCCUPANCY REVIEW", "POSSESSION PROCESS", "POSSESSION OBTAINED", "PROPERTY SECURED",
  "REHAB", "COMPLETED",
];

export const LEGAL_DISCLAIMER =
  "Vertexhub Ventures is an independent real estate investor support company. Vertexhub Ventures is not a governmental agency, sheriff, treasurer, court or auction platform. Unless specifically disclosed otherwise, Vertexhub Ventures is not acting as a law firm, title company, bank or direct lender. Information provided through this website is for general informational and administrative-support purposes and does not constitute legal, tax, investment, brokerage or title advice. Auction requirements and deadlines may change. Customers are responsible for independently verifying official auction requirements and obtaining appropriate professional advice.";

export const FINANCING_DISCLAIMER =
  "Financing programs may be offered by independent third-party lenders, mortgage professionals or financing providers. Loan approval is not guaranteed. Rates, fees, loan amounts, leverage, credit requirements, DSCR requirements, property eligibility and other terms are determined by the applicable financing provider and may change without notice. Any financing activity requiring licensing must be performed only by appropriately licensed entities or professionals.";
